import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 Authorization: `Bearer ${getToken()}`,
 "Content-Type": "application/json",
 },
});

/**
 * ===============================
 * ADMIN EVENTS SERVICE
 * ===============================
 */


/**
 * Get all events
 */
export const fetchAllEvents = async () => {

 try {

 const response = await api.get("/admin/events");

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch events",
 };

 }

};


/**
 * Get event by ID
 */
export const fetchEventById = async (id) => {

 try {

 const response = await api.get(`/admin/events/${id}`);

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch event",
 };

 }

};


/**
 * Create new event
 */
export const createEvent = async (event) => {

 try {

 const response = await api.post(
 "/admin/events",
 event
 );

 return {
 status: response.status,
 data: response.data,
 message: "Event created successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to create event",
 };

 }

};


/**
 * Update event
 */
export const updateEvent = async (id, event) => {

 try {

 const response = await api.put(
 `/admin/events/${id}`,
 event
 );

 return {
 status: response.status,
 data: response.data,
 message: "Event updated successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to update event",
 };

 }

};


/**
 * Delete event
 */
export const deleteEvent = async (id) => {

 try {

 const response = await api.delete(
 `/admin/events/${id}`
 );

 return {
 status: response.status,
 message: "Event deleted successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to delete event",
 };

 }

};


/**
 * Cancel event
 */
export const cancelEvent = async (id) => {

 try {

 const response = await api.put(
 `/admin/events/${id}/cancel`
 );

 return {
 status: response.status,
 data: response.data,
 message: "Event cancelled successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to cancel event",
 };

 }

};


/**
 * Reschedule event
 */
export const rescheduleEvent = async (id, rescheduleData) => {

 try {

 const response = await api.put(
 `/admin/events/${id}/reschedule`,
 rescheduleData
 );

 return {
 status: response.status,
 data: response.data,
 message: "Event rescheduled successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to reschedule event",
 };

 }

};


/**
 * Generate Zoom link for event
 */
export const generateZoomLink = async (eventId) => {

 try {

 const response = await api.post(
 `/admin/events/${eventId}/generate-zoom`
 );

 return {
 status: response.status,
 data: response.data,
 message: response.data?.message || "Zoom link processed",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to generate Zoom link",
 };

 }

};

/**
 * Get registered users
 */
export const fetchEventUsers = async (eventId) => {

 try {

 const response = await api.get(
 `/admin/events/${eventId}/users`
 );

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch users",
 };

 }

};

/**
 * Delete user from event
 */
export const deleteEventUser = async (eventId, bookingId) => {

 try {

 const response = await api.delete(
 `/admin/events/${eventId}/users/${bookingId}`
 );

 return {
 status: response.status,
 data: response.data,
 message: response.data?.message || "User removed successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to remove user",
 };

 }

};

/**
 * Get event payments
 */
export const fetchEventPayments = async (eventId) => {

 try {

 const response = await api.get(
 `/admin/events/${eventId}/payments`
 );

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: [],
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch payments",
 };

 }

};

/**
 * Get event analytics
 */
export const fetchEventAnalytics = async (eventId) => {

 try {

 const response = await api.get(
 `/admin/events/${eventId}/analytics`
 );

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch analytics",
 };

 }

};

/**
 * Get event availability
 */
export const fetchEventAvailability = async (eventId) => {

 try {

 const response = await api.get(
 `/admin/events/${eventId}/availability`
 );

 return {
 status: response.status,
 data: response.data,
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to fetch availability",
 };

 }

};

/**
 * Bulk event operations
 */
export const bulkUpdateEvents = async (eventIds, updateData) => {

 try {

 const response = await api.put(
 "/admin/events/bulk-update",
 {
 eventIds,
 updateData
 }
 );

 return {
 status: response.status,
 data: response.data,
 message: "Events updated successfully",
 };

 } catch (err) {

 return {
 status: err.response?.status || 500,
 data: null,
 message:
 err.response?.data?.message ||
 err.message ||
 "Failed to update events",
 };

 }

};